import "../styles/HeaderStyle.css"
import { useNavigate, useLocation } from "react-router-dom";
import carnLogo from"../assets/HomepageAssets/carnival--600.png"
import { useRef } from "react"

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const lastClick = useRef(0);

  const handleNavClick = (path) => {
    const now = Date.now();
    if (now - lastClick.current < 500) return; // ignore double-clicks within 500ms
    lastClick.current = now;

    navigate(path);
  };

  return (
    <header className="header">
      <div className="header-left">
        <img src={carnLogo} alt="CarnCorp" className="logo" onClick={() => handleNavClick("/")}/>
        <h1>Tanner Culley, Business Analyst</h1>
      </div>

      <nav className="nav-buttons">
        {location.pathname !== "/" && (
          <button className="btn" onClick={() => handleNavClick("/")}>
            Home
          </button>
        )}
        {location.pathname !== "/About" && (
          <button className="btn" onClick={() => handleNavClick("/About")}>
            About
          </button>
        )}
        {location.pathname !== "/MyReads" && (
          <button className="btn" onClick={() => handleNavClick("/MyReads")}>
            My Reads
          </button>
        )}
        {location.pathname !== "/Resume" && (
          <button className="btn" onClick={() => handleNavClick("/Resume")}>
            Resume
          </button>
        )}
      </nav>
    </header>
  );
}

export default Header;